import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { map } from "rxjs";
import { haFattoIlRadar } from "../../../shared/utils/radar/accesso-radar.utils";
import { ROUTE } from "../../../shared/utils/routes";
import { AuthService } from "../../services/auth/auth.service";

/**
 * Il Radar lo apre solo chi ha compilato il questionario.
 *
 * Nascondere la voce di menu non basta: l'indirizzo si può digitare, arrivare
 * da un vecchio segnalibro o da un collegamento mandato da un collega, e chi
 * non ha un Radar troverebbe una pagina vuota — che si legge come un guasto,
 * non come «questa cosa non è tua».
 *
 * Chi non ce l'ha torna alla bacheca delle aziende invece di vedere un errore:
 * non ha sbagliato niente, è una sezione che non gli appartiene.
 *
 * Con un TEM che guarda un cliente vale il **cliente**: è il suo Radar quello
 * di cui si sta parlando.
 */
export const radarGuard: CanActivateFn = () => {
  const router = inject(Router);

  return inject(AuthService)
    .getCurrentUserAndOnBehalfOfUser()
    .pipe(
      map(({ currentUser, onBehalfOfUser }): boolean | UrlTree => {
        if (haFattoIlRadar(onBehalfOfUser ?? currentUser)) {
          return true;
        }

        return router.parseUrl(ROUTE.COMPANIES_DASHBOARD);
      })
    );
};
